import { RotateCcwIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'

export function ConversationLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center text-center px-4 py-8 bg-white-alpha-4 border border-destructive rounded-xl">
      <h3 className="text-xl font-bold text-destructive mb-3">
        Couldn't load this conversation
      </h3>
      <p className="text-base text-destructive mb-6">
        Something went wrong loading your messages. Your conversation is safe —
        try again.
      </p>
      <Button
        variant="destructive"
        onClick={onRetry}
        className="flex items-center gap-2">
        <RotateCcwIcon className="w-4 h-4" />
        Retry
      </Button>
    </div>
  )
}
